import React from 'react';
import { TrendingUpIcon, UsersIcon, WalletIcon, DollarSignIcon, AlertCircleIcon, CheckCircleIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
const CashbackDashboard: React.FC = () => {
  // Mock data
  const activeCampaigns = [{
    id: 'CB-2023-001',
    name: 'Q3 Merchant Activation',
    budget: 5000000,
    utilized: 2450000,
    merchants: 1250,
    payouts: 1800000,
    status: 'active'
  }, {
    id: 'CB-2023-002',
    name: 'Digital Week Bonanza',
    budget: 1000000,
    utilized: 850000,
    merchants: 450,
    payouts: 850000,
    status: 'active'
  }, {
    id: 'CB-2023-003',
    name: 'Super Merchant Rewards',
    budget: 10000000,
    utilized: 1200000,
    merchants: 85,
    payouts: 0,
    status: 'active'
  }];
  const columns = [{
    header: 'Campaign Name',
    accessor: 'name'
  }, {
    header: 'Budget Utilization',
    accessor: (row: any) => {
      const percentage = Math.round(row.utilized / row.budget * 100);
      return <div className="w-32" data-id="element-3485">
            <div className="flex justify-between text-xs mb-1" data-id="element-3486">
              <span data-id="element-3487">{percentage}%</span>
              <span className="text-gray-500" data-id="element-3488">
                PKR {(row.utilized / 1000000).toFixed(1)}M
              </span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-3489">
              <div className={`h-1.5 rounded-full ${percentage > 90 ? 'bg-red-500' : 'bg-green-500'}`} style={{
            width: `${percentage}%`
          }} data-id="element-3490"></div>
            </div>
          </div>;
    }
  }, {
    header: 'Qualified Merchants',
    accessor: 'merchants'
  }, {
    header: 'Pending Payouts',
    accessor: (row: any) => `PKR ${row.payouts.toLocaleString()}`
  }, {
    header: 'Status',
    accessor: (row: any) => <StatusBadge status="success" text="Active" data-id="element-3491" />
  }];
  return <div className="space-y-6" data-id="element-3492">
      <div data-id="element-3493">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-3494">
          Cashback Incentive Dashboard
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-3495">
          Overview of merchant cashback performance and budget utilization
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-3496">
        <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-3497">
          <div className="flex items-center" data-id="element-3498">
            <div className="p-3 rounded-full bg-blue-500 text-white mr-4" data-id="element-3499">
              <WalletIcon className="h-6 w-6" data-id="element-3500" />
            </div>
            <div data-id="element-3501">
              <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-3502">
                Total Budget
              </p>
              <p className="text-2xl font-bold text-blue-900 dark:text-blue-100" data-id="element-3503">
                PKR 25.0M
              </p>
            </div>
          </div>
        </Card>

        <Card className="bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800" data-id="element-3504">
          <div className="flex items-center" data-id="element-3505">
            <div className="p-3 rounded-full bg-green-500 text-white mr-4" data-id="element-3506">
              <CheckCircleIcon className="h-6 w-6" data-id="element-3507" />
            </div>
            <div data-id="element-3508">
              <p className="text-sm font-medium text-green-600 dark:text-green-400" data-id="element-3509">
                Utilized Budget
              </p>
              <p className="text-2xl font-bold text-green-900 dark:text-green-100" data-id="element-3510">
                PKR 8.4M
              </p>
            </div>
          </div>
        </Card>

        <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-3511">
          <div className="flex items-center" data-id="element-3512">
            <div className="p-3 rounded-full bg-purple-500 text-white mr-4" data-id="element-3513">
              <UsersIcon className="h-6 w-6" data-id="element-3514" />
            </div>
            <div data-id="element-3515">
              <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-3516">
                Qualified Merchants
              </p>
              <p className="text-2xl font-bold text-purple-900 dark:text-purple-100" data-id="element-3517">
                1,842
              </p>
            </div>
          </div>
        </Card>

        <Card className="bg-orange-50 dark:bg-orange-900/20 border-orange-100 dark:border-orange-800" data-id="element-3518">
          <div className="flex items-center" data-id="element-3519">
            <div className="p-3 rounded-full bg-orange-500 text-white mr-4" data-id="element-3520">
              <DollarSignIcon className="h-6 w-6" data-id="element-3521" />
            </div>
            <div data-id="element-3522">
              <p className="text-sm font-medium text-orange-600 dark:text-orange-400" data-id="element-3523">
                Pending Payouts
              </p>
              <p className="text-2xl font-bold text-orange-900 dark:text-orange-100" data-id="element-3524">
                PKR 2.1M
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3525">
        <div className="lg:col-span-2" data-id="element-3526">
          <Card title="Live Campaign Performance" data-id="element-3527">
            <Table columns={columns} data={activeCampaigns} keyField="id" pagination={false} data-id="element-3528" />
          </Card>
        </div>
        <div data-id="element-3529">
          <Card title="Alerts & Notifications" data-id="element-3530">
            <div className="space-y-4" data-id="element-3531">
              <div className="flex items-start p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-md border border-yellow-100 dark:border-yellow-800" data-id="element-3532">
                <AlertCircleIcon className="h-5 w-5 text-yellow-600 mr-3 mt-0.5" data-id="element-3533" />
                <div data-id="element-3534">
                  <p className="font-medium text-sm text-gray-900 dark:text-white" data-id="element-3535">
                    Budget Threshold Reached
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-3536">
                    Digital Week Bonanza has reached 85% utilization.
                  </p>
                </div>
              </div>
              <div className="flex items-start p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md border border-blue-100 dark:border-blue-800" data-id="element-3537">
                <TrendingUpIcon className="h-5 w-5 text-blue-600 mr-3 mt-0.5" data-id="element-3538" />
                <div data-id="element-3539">
                  <p className="font-medium text-sm text-gray-900 dark:text-white" data-id="element-3540">
                    High Participation
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-3541">
                    Q3 Merchant Activation seeing 20% higher enrollment than
                    projected.
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};
export default CashbackDashboard;